module.exports = __webpack_public_path__ + "media/4x3/pm-1e97e8d7.svg";